import * as types from "./types";

export default {
  [types.SET_ACTIVE_DATA](state, payload) {
    state.activeData.scale = payload.scale;
    state.activeData.sector = payload.sector;
  },
  [types.SET_ACTIVE_LAYER_GROUP](state, name) {
    state.activeLayerGroup = name;
  },
  [types.SHOW_SUITABILITY_LAYER](state, wmsLayerSuitability) {
    state.wmsLayerSuitability = {
      ...state.wmsLayerSuitability,
      ...wmsLayerSuitability
    };
  },
  [types.HIDE_SUITABILITY_LAYER](state) {
    state.wmsLayerSuitability.visible = false;
  },
  [types.CLEAN_MAP](state) {
    state.wmsLayerSuitability.visible = false;
  },
  [types.SET_MARKER](state, point) {
    state.marker = {
      ...state.marker,
      ...point
    };
  },
  [types.RESET_LAYER_GROUP](state) {
    state.activeLayerGroup = "";
  }
};
